import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { MechanicalByHeatReducer } from "./MechanicalByHeatReducer";

const MechanicalByHeatContext = createContext({
	state: MechanicalByHeatReducer.getInitialState(),
	actions: MechanicalByHeatReducer.actions,
});

export const useMechanicalByHeatContext = () =>
	useContext(MechanicalByHeatContext);

export const MechanicalByHeatProvider = ({
	children,
}: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: MechanicalByHeatReducer.getInitialState(),
		reducers: MechanicalByHeatReducer.caseReducers,
	});
	return (
		<MechanicalByHeatContext.Provider value={{ state, actions }}>
			{children}
		</MechanicalByHeatContext.Provider>
	);
};
